/*
 * This is used to debounce requests to try and prevent the api from getting
 * hit multiple times everytime a filter is updated. Lifted from the old app
 */
import { useState, useEffect } from "react";

const useDebounced = <T>(value: T, delay: number) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timeout = setTimeout(() => setDebounced(value), delay);

        return () => clearTimeout(timeout);
    }, [value, delay]);

    return debounced;
};

export default useDebounced;
